import { GalleryController } from "../../../components/gallery/controller.js";
import { ModalController } from "../../../components/modal/controller.js";

export class UserPrivateServiceView {
  constructor() {
    this.gallery = new GalleryController('app.userPrivateController.servicios.view');
  }

  renderMain() {
    return `
      <div class="user-header">
        <h1>Mis servicios</h1>
      </div>
      `;
  }

  renderForm(_data) {
    let isNew = false;
    if (!_data) {
      _data = {};
      isNew = true;
    }
    let html = `
    <div class="form">
      <input type="hidden" id="servicios-idcod" value="${_data.idcod || ''}"> 
      <h2 class="mb0 ancho">Datos de mi servicio</h2>
      <div class="group sb">
        <div class="group">
          <b>Categoría</b>
          <select id="servicios-categoria" value="${_data.categoria || ''}"></select>
          <span id="servicios-categoria-error"></span>
        </div>
        <div class="group">
          <b>Título</b>
          <input type="text" id="servicios-titulo" value="${_data.titulo || ''}"> 
          <span id="servicios-titulo-error"></span>
        </div>
        <div class="group">
          <b>Descripción corta</b>
          <textarea id="servicios-resumen" rows="5">${_data.resumen || ''}</textarea> 
          <span id="servicios-resumen-error"></span>
        </div>
      </div>
      <div class="group">
        <b>Imágenes</b>
        ${this.gallery.create(_data.imagenes)}
      </div>
      ${app.userPrivateController.view.renderPriceOptions('servicios', _data, isNew)}
      <div class="group">
        <b>Provincia</b>
        <select id="servicios-provincia" value="${_data.provincia || ''}" onchange="
        APICRUD.Location.Selector_LoadCities('servicios-localidad', this.value, '${_data.localidad}')
        "></select>
        <span id="servicios-idState-error"></span>
      </div>
      <div class="group">
        <b>Localidad</b>
        <select id="servicios-localidad" value="${_data.localidad || ''}"></select>
        <span id="servicios-localidad-error"></span>
      </div>
      <div class="group">
        <b>Radio de acción</b>
        <select id="servicios-radio-de-accion" value="${_data['radio '] || ''}"></select>
        <span id="servicios-radio-de-accion-error"></span>
      </div>
      <div class="group">
        <b>Maquinaria</b>
        <textarea id="servicios-maquinas" rows="5">${_data.maquinas || ''}</textarea>
        <span id="servicios-maquinas-error"></span>
      </div>
      <div class="group">
        <b>Software</b>
        <textarea id="servicios-software" rows="5">${_data.software || ''}</textarea>
        <span id="servicios-software-error"></span>
      </div>
      <div class="group span">
          <b>Descripción completa del servicio</b>
          <textarea id="servicios-descripcion" rows="10">${_data.descripcion || ''}</textarea> 
          <span id="servicios-descripcion-error"></span>
      </div>
    </div>
    <div class="form-footer">
      <button class="mt20" onclick="app.userPrivateController.servicios.save()">${_data.idcod ? 'Guardar cambios' : 'Crear servicio'}</button>
    `;

    if (_data.idcod) {
      html += `
        <button class="mt20 bg-red fr" onclick="app.userPrivateController.servicios.delete('${_data.titulo || ''}', '${_data.idcod || ''}')">Eliminar</button>
      `;
    }

    html += `
      <span id="servicios-status" class="mt20"></span>
    </div>
    `;

    return html;
  }

  renderItemCollection(_items) {
    let html = '';
    html += '<div class="content items">';

    if (_items.data.length > 0) {
      html = `
        <div class="user-header-content">
          <h1>Mis servicios</h1>
          <button onclick="app.userPrivateController.servicios.new()">+ Nuevo servicio</button>
        </div>
        <div class="content items">
          ${_items.data.map(i => this.renderItem(i)).join('')}
        </div>
        `;
    } else {
      html = `
        <div class="user-header-content">
          <h1>Mis servicios</h1>
          <button onclick="app.userPrivateController.servicios.new()">+ Nuevo servicio</button>
        </div>
        <p> No hay publicaciones, cree su primer servicio ahora. </p>
        <br>
        <button onclick="app.userPrivateController.servicios.new()">+ Crear mi primer servicio</button>
        `;
    }
    return html;
  }

  renderItem(_item) {
    let images = _item.imagenes;
    if (images && typeof images == 'string' && images.length > 0) {
      try {
        images = JSON.parse(images);
      } catch (error) {
        console.log(error, images);
      }
    }
    if (!Array.isArray(images)) {
      images = [];
    }
    return `
    <article>
      <div class="item pb20" onclick="app.userPrivateController.servicios.edit('${_item?.idcod}')">
        <img src="${images.length > 0 ? APICRUD.Image.GetUrl(images[0]) : ''}" alt="" onerror="this.src='/assets/img/servicios.webp'">
        <h1>${_item?.titulo || 'Sin título'}</h1>
        <p>${_item?.resumen || ''}</p>
      </div>
    </article>
  `;
  }

  renderDeleteConfirmation(_title, _idcod) {
    return ` <h2>¿Seguro desea eliminar el servicio <b class="cr">${_title}</b>?</h2>
      <button class="bg-red" onclick="app.userPrivateController.servicios.deleteConfirmation('${_idcod}')">Eliminar</button>
      <button class="fr" onclick="app.userPrivateController.servicios.deleteCancel()">Conservar</button>
      `;
  }
}
